export const formatTransactionAddress = (address) => {
  if (address) {
    return `${address.Line1}${address.Line2 ? ' #' + address.Line2 : ''},  ${address.City}, ${
      address.State
    }`;
  }

  return '';
};

export function isTransactionEmpty(transaction: any): boolean {
  const fieldsToCheck = [
    'CloseDate',
    'ClosePrice',
    'ClosingDate',
    'EffectiveDate',
    'ListingExpireDate',
    'Notes',
    'Price',
    'PropertyType',
  ];

  return fieldsToCheck?.every((field) => transaction?.[field] === undefined);
}
